// Keep this first: it must run before App's Better Auth and shared-schema
// dependency graph creates any Zod object schemas.
import "./lib/configure-zod";
import { render } from "preact";
import { App } from "./app";
import "./styles/globals.css";

const root = document.getElementById("app");
if (!root) throw new Error("#app not found");
render(<App />, root);
